import { render, staticRenderFns } from "./LegalEntity.vue?vue&type=template&id=8df27568&scoped=true"
import script from "./LegalEntity.vue?vue&type=script&lang=js"
export * from "./LegalEntity.vue?vue&type=script&lang=js"
import style0 from "./LegalEntity.vue?vue&type=style&index=0&id=8df27568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df27568",
  null
  
)

export default component.exports